import {Component, Inject, Injectable, OnInit} from '@angular/core';
import {ApiService} from '../../shared/services/api.service';
import {InternalService} from "../../shared/services/internal.service";



@Component({
  selector: "app-admin-layout",
  templateUrl: "./admin-layout.component.html",
  styleUrls: ["./admin-layout.component.scss"]
})
export class AdminLayoutComponent implements OnInit {
  public sidebarColor: string = "red";

  constructor(public apiService: ApiService,public internalService: InternalService) {
  }
  changeSidebarColor(color){
    var sidebar = document.getElementsByClassName('sidebar')[0];
    var mainPanel = document.getElementsByClassName('main-panel')[0];

    this.sidebarColor = color;

    if(sidebar != undefined){
        sidebar.setAttribute('data',color);
    }
    if(mainPanel != undefined){
        mainPanel.setAttribute('data',color);
    }
  }
  changeDashboardColor(color){
    var body = document.getElementsByTagName('body')[0];
    if (body && color === 'white-content') {
        body.classList.add(color);
        this.internalService.darkContent =false
    }
    else if(body.classList.contains('white-content')) {
      body.classList.remove('white-content');
      body.classList.add('black-content');
      this.internalService.darkContent= true
    }
  }
  ngOnInit() {

    if(this.apiService.currentDirection === 'rtl') {
      // on this page, we need on the body tag the classes .rtl and .menu-on-right
      document.body.classList.add('rtl', 'menu-on-right');
      // we also need the rtl bootstrap
      // so we add it dynamically to the head
      let head = document.head;
      let link = document.createElement('link');
      link.type = 'text/css';
      link.rel = 'stylesheet';
      link.id = 'rtl-id';
      link.href =
        'https://cdnjs.cloudflare.com/ajax/libs/bootstrap-rtl/3.4.0/css/bootstrap-rtl.css';
      head.appendChild(link);
    }
  }
}
